import { useQuery } from '@tanstack/react-query'
import type { BackofficeSpendControlRuleDtoV1 } from 'api/swagger/definitions/backoffice'
import { getRule } from 'SpendControl/endpoints'
import type { SpendControlTableProps } from 'SpendControl/SpendControlTable'

export const useRule: SpendControlTableProps['useRule'] = ({ id }) => {
  const { data, isLoading } = useQuery({
    queryKey: ['get-spend-rule', id],
    queryFn: () => getRule(id),
  })

  return {
    data: data as Required<BackofficeSpendControlRuleDtoV1>,
    isLoading,
  }
}
